<div class="banner w-100 h-100 d-flex align-items-center">
    <div 
        class="d-flex align-items-center pl-4 w-33" 
        [class.invisible]="!hasPerms()"
    >
        <span class="font-weight-bold pr-2">Current Workstation:</span>
        @if (isSelectingWorkstation()) {
            <div (click)="$event.stopPropagation()">
                <p-select 
                    #workstationSelect
                    (onHide)="toggleWorkstationSelecting(false)"
                    size="small"
                    [options]="workstationOptions()"
                    optionLabel="text"
                    optionValue="value"
                    [ngModel]="$safeNavigationMigration(workstation()?.shippingWorkstationId)"
                    (ngModelChange)="setWorkstation($event)"
                    style="min-width: 18rem;"
                />
            </div>
        } @else {
            <span 
                class="workstation-name cursor-pointer" 
                [ngClass]="{'text-danger font-weight-bold': !workstation()?.workstationName}"
                (click)="toggleWorkstationSelecting()"
            >{{ workstation()?.workstationName ?? 'None Selected' }}</span>
        }
    </div>


    <div class="w-33 text-center">
        @if (isSelectingInventory()) {
            <p-select
                style="min-width: 175px;"
                #inventorySelect
                size="small"
                (onHide)="toggleInventorySelection()"
                [options]="inventoryOptions()"
                optionLabel="text"
                optionValue="value"
                [(ngModel)]="selectedInventoryId"
                (ngModelChange)="changeInventory($event)"
            />
        } @else {
            @if (
                gvs.invName() != null 
                && gvs.invName() != ''
            ) {
                <span
                    class="workstation-name cursor-pointer"
                    (click)="toggleInventorySelection()"
                >▼ {{ gvs.invName() }}</span>
            }
        }
    </div>

    <div class="w-33 invisible">hidden</div>
</div>